module.exports = __webpack_public_path__ + "static/media/view1.6889a3b7.jpeg";